import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import { Helmet } from "react-helmet";
import Header from '../common/ToolsHeader';
import Settings from './settings';
import React from 'react';
import Tabs from './tabs';
import MobileCover from '../common/MobileCover';
import Authentication from '../common/Authentication';
import { useUserId, userSubscribed } from '../utils/authentication';
import LoginRegisterContainer from '../common/LoginRegisterContainer';
import { useSelector } from 'react-redux';
import { IRootState } from '../../store/reducer';
import Subscribe from '../common/Subscribe';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    minHeight: '100vh',
    backgroundColor: '#000A16',
    color: theme.palette.common.white,
    fontFamily: 'Roboto',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  contentWrapper: {
    flexGrow: 1,
    paddingBottom: 40,
  }
})
);

const queryClient = new QueryClient();


const PreContestSim = () => {
  const classes = useStyles();
  const userId = useUserId();
  const { authenticated, selectedSite, selectedSport } = useSelector((state: IRootState) => state.common);
  const isUserSubscribed = userSubscribed(authenticated, selectedSite, selectedSport);

  return (
    <QueryClientProvider client={queryClient}>
      <Authentication app='DATAHUB'>
        <Helmet>
          <title>Post-Contest Simulator</title>
          <meta name='description' content='Stokastic Post-Contest Simulator' />
        </Helmet>
        <MobileCover>
          <Grid className={classes.root}>
            <Grid item xs={12}><Header /></Grid>
            {
              userId ? (
                <>
                  <Grid item xs={12} lg={12}><Settings /></Grid>
                  <Grid container item xs={12} spacing={1} className={classes.contentWrapper}>
                    { isUserSubscribed ? <Grid item xs={12} lg={12}><Tabs /></Grid> : <Subscribe toolName='Post-Contest Simulator' /> }
                  </Grid>
                </>
              ) : <LoginRegisterContainer toolName='Post-Contest Simulator' />
            }
          </Grid>
        </MobileCover>
      </Authentication>
    </QueryClientProvider>
  )
}

export default PreContestSim;